

















import {Component, Vue} from 'vue-property-decorator';

@Component
export default class SignIn extends Vue {

    public email: string = '';
    public password: string = '';

    public async signIn(): Promise<void> {
        await this.$locator.api.signIn(this.email, this.password);
        await this.$locator.routing.home();
    }
}
